// SB Flags
export const IS_SESSIONBOARD_ADMIN = { NAME: "isSessionboardAdmin" };
export const IS_SESSIONBOARD_SALES = { NAME: "isSessionboardSales" };
export const IS_CUSTOMER_SUCCESS = { NAME: "isCustomerSuccess" };
export const CAN_VIEW_SESSIONBOARD_APPLICATIONS = {
  NAME: "canViewSessionboardApplications"
};

export const CAN_VIEW_IMPORTING = {
  NAME: "sbViewImporting"
};
export const CAN_VIEW_PERMISSIONS = {
  NAME: "sbViewPermissions"
};
export const CAN_VIEW_CONTACT_MEMBERS = {
  NAME: "sbViewContactMembers"
};
export const CAN_VIEW_INTEGRATIONS_LOG = {
  NAME: "sbViewIntegrationsLog"
};
export const CAN_VIEW_DOCUMENT_GENERATION = {
  NAME: "sbViewDocumentGeneration"
};
export const CAN_VIEW_REPORT_BUILDER = {
  NAME: "sbViewReportBuilder"
};
export const CAN_VIEW_CONTINUOUS_SYNC = {
  NAME: "sbViewContinuousSync"
};
export const CAN_VIEW_ACTIVITY_FEED = {
  NAME: "sbViewActivityFeed"
};
export const CAN_VIEW_EMAIL_CUSTOM_HTML = {
  NAME: "sbViewEmailCustomHtml"
};
export const CAN_VIEW_NEW_INTEGRATIONS = {
  NAME: "sbViewNewIntegrations"
};
export const CAN_VIEW_MANY_RECORDS = {
  NAME: "sbCanViewManyRecords"
};
export const CAN_VIEW_SESSION_PROFILE = {
  NAME: "sbViewSessionProfile"
};
export const CAN_VIEW_CUSTOM_STATUSES = {
  NAME: "sbViewCustomStatuses"
};
export const CAN_VIEW_EVALUATION_PLAN_LIMITS = {
  NAME: "sbViewEvaluationPlanLimits"
};
export const CAN_VIEW_AGENDA_SETTINGS = {
  NAME: "sbViewAgendaSettings"
};
export const CAN_USE_SESSION_TASKS = {
  NAME: "sbViewSessionTasks"
};
export const CAN_VIEW_ADVANCED_PORTAL = {
  NAME: "sbViewAdvancedPortal"
};
export const CAN_VIEW_DEDUPE = {
  NAME: "sbViewDedupe"
};
export const CAN_VIEW_EDIT_DOCUMENT = {
  NAME: "sbViewEditDocument"
};
export const CAN_VIEW_VIRTUAL_EVALUATORS = {
  NAME: "sbViewVirtualEvaluators"
};
export const CAN_VIEW_ZAPIER = {
  NAME: "sbViewZapier"
};
export const CAN_VIEW_BULK_DOWNLOAD_FILE_REQUESTS = {
  NAME: "sbViewBulkDownloadFileRequests"
};
export const CAN_VIEW_CRM_DASHBOARD = {
  NAME: "sbViewCrmDashboard"
};

/*
@NOTE: Example with multi variant

export const EXAMPL
E_WITH_MULTI_VARIANT = {
  NAME: 'testFlag',
  VARIATES: {
    A: 'testFlagA',
    B: 'testFlagB'
  }
};
*/
